import React from 'react';
import logo from './logo.svg';
import { RedocStandalone } from 'redoc';

function App() {
  return (
    <div className="App">
      <RedocStandalone specUrl={`${process.env.PUBLIC_URL}/swagger.yaml`} />
    </div>
  );
}

export default App;
